import { enTranslations } from './translations.en';

export const frTranslations: Record<string, string> = {
  ...enTranslations,
  'nav.overview': 'Vue d’ensemble',
  'nav.overviewDesc': 'État opérationnel, orchestration et canaux de diffusion',
  'nav.reception': 'Réception',
  'nav.receptionDesc': 'Listes opérationnelles, émission manuelle et import massif',
  'nav.administration': 'Administration',
  'nav.administrationDesc':
    'Listes et formulaires dédiés pour les tenants, vendors, sites, utilisateurs et infrastructures',
  'shell.consoleTitle': 'Console opérationnelle',
  'shell.consoleDescription':
    'Tableau de bord multi-tenant pour les flux PMS, les processus de réception, le provisionnement du contrôleur réseau et la distribution DPSK.',
  'shell.livePosture': 'État en direct',
  'shell.loadingLocation': 'Chargement du contexte du site',
  'shell.healthy': 'Flux opérationnel stable',
  'shell.attention': 'Attention sur le canal de diffusion',
  'shell.authSession': 'Session authentifiée',
  'shell.guestOperator': 'Opérateur démo',
  'shell.noRole': 'Aucun rôle',
  'shell.currentWorkspace': 'Espace de travail courant',
  'shell.workspaceDescription': 'Contexte actif pour la page sélectionnée.',
  'shell.filters': 'Filtres',
  'shell.tenant': 'Tenant',
  'shell.location': 'Hôtel / Site',
  'shell.language': 'Langue',
  'shell.theme': 'Thème',
  'shell.theme.system': 'Système',
  'shell.theme.light': 'Clair',
  'shell.loadingData': 'Mise à jour des données',
  'shell.searchTenant': 'Rechercher un tenant',
  'shell.searchLocation': 'Rechercher un hôtel ou un site',
  'shell.noSearchResults': 'Aucun résultat',
  'shell.closeFilters': 'Fermer les filtres',
  'dialog.cancel': 'Annuler',
  'dialog.deleteTitle': 'Confirmer la suppression',
  'dialog.extendTitle': 'Confirmer l’extension',
  'dialog.revokeTitle': 'Confirmer la révocation',
  'shell.noPms': 'Aucun PMS lié',
  'shell.noController': 'Aucun contrôleur lié',
  'shell.tvOn': 'TV active',
  'shell.tvPending': 'TV en attente',
  'shell.emailOn': 'E-mail actif',
  'shell.emailPending': 'E-mail en attente',
  'shell.exitSession': 'Quitter',
  'auth.mode.mock': 'Mode démo',
  'login.badge': 'Console opérationnelle hospitality',
  'login.title': 'Accès sécurisé à la plateforme hospitality.',
  'login.description':
    'Gérez tenants, sites, utilisateurs, vendors et identifiants Wi‑Fi depuis une console unique conçue pour l’exploitation quotidienne.',
  'login.inputTitle': 'Tenants et sites',
  'login.inputBody': 'Pilotez établissements, unités, vendors et paramètres opérationnels depuis un seul point.',
  'login.logicTitle': 'Réception et identifiants',
  'login.logicBody':
    'Émettez, renouvelez et surveillez les codes Wi‑Fi pour les clients, le personnel et les événements sans étapes supplémentaires.',
  'login.outputTitle': 'Visibilité opérationnelle',
  'login.outputBody': 'Consultez l’état du service, les files d’attente et la distribution des identifiants en un coup d’œil.',
  'login.accessMode': 'Accès',
  'login.demoWorkspace': 'Découvrir la plateforme',
  'login.keycloakWorkspace': 'Bon retour',
  'login.demoDescription': 'Ouvrez l’environnement de démonstration pour explorer les principaux flux avec des données d’exemple.',
  'login.keycloakDescription': 'Connectez-vous avec votre compte d’entreprise pour continuer.',
  'login.enterDemo': 'Ouvrir le tableau de bord démo',
  'login.continueKeycloak': 'Accéder à la plateforme',
  'login.readyTitle': 'Gestion centralisée',
  'login.readyBody':
    'Tenants, sites, unités, utilisateurs et catalogues sont disponibles dans une seule console opérationnelle.',
  'login.supportTitle': 'Opérations quotidiennes',
  'login.supportBody':
    'Travaillez sur les flux de réception, les identifiants Wi‑Fi et les paramètres de service avec une expérience plus simple.',
  'login.demoNote': 'L’environnement de démonstration utilise des données d’exemple et sert uniquement à l’exploration.',
  'login.switchNote': 'Si vous rencontrez des problèmes de connexion, contactez l’administrateur du service.',
  'overview.context': 'Vue opérationnelle',
  'overview.title': 'État du site sélectionné',
  'overview.subtitle':
    'Indicateurs rapides sur l’utilisation DPSK, le mapping VLAN et la charge opérationnelle du site.',
  'reception.pageKicker': 'Opérations de réception',
  'reception.pageTitle': 'Émission des DPSK et gestion du cycle de vie',
  'reception.pageDescription':
    'La zone réception est organisée en pages dédiées : liste des codes, émission manuelle et import massif.',
  'admin.pageKicker': 'Gestion administrative',
  'admin.pageTitle': 'Tenants, vendors, sites et utilisateurs',
  'admin.pageDescription':
    'La zone administrative utilise des pages dédiées pour les tenants, les catalogues vendor, les sites, les utilisateurs et l’infrastructure.',
  'admin.actions.newRoomAssignment': 'Nouvelle unité',
  'admin.actions.assignRoom': 'Modifier l’unité',
  'admin.form.createRoomAssignment': 'Créer une unité',
  'admin.form.updateRoomAssignment': 'Mettre à jour l’unité',
  'admin.form.roomAssignmentDescription':
    'Définissez le mappage Wi‑Fi d’une unité individuelle. La configuration devient immédiatement disponible dans l’inventaire du site et dans les flux de réception.',
  'admin.form.roomNotFound': 'Unité introuvable.',
  'admin.form.locationRequiredForRoom':
    'Sélectionnez d’abord un site avant d’enregistrer une unité.',
  'admin.message.roomAssignmentSaved':
    'Configuration d’infrastructure enregistrée pour {name}.',
  'table.pagination.previous': 'Précédent',
  'table.pagination.next': 'Suivant',
  'table.pagination.summary': '{from}-{to} sur {total}',
  'app.badge': 'Lumen Hospitality DPSK',
  'auth.mode.keycloak': 'Keycloak',
  'login.realm': 'Realm',
  'login.clientId': 'Client ID',
  'login.endpoint': 'Endpoint',
  'overview.card.active.label': 'Identités actives',
  'overview.card.active.caption': 'DPSK actuellement valides sur le site sélectionné',
  'overview.card.scheduled.label': 'Arrivées planifiées',
  'overview.card.scheduled.caption': 'Identifiants déjà créés et en attente du check-in ou du début de l’événement',
  'overview.card.mapped.label': 'Unités mappées',
  'overview.card.mapped.caption': '{rooms} chambres, {publicAreas} espaces communs, {eventHalls} salles événementielles',
  'overview.card.daily.label': 'Volume journalier',
  'overview.card.daily.caption': 'Charge prévue entre PMS, réception et demandes manuelles',
  'overview.locationHealth': 'État des services',
  'overview.deliveryChannels': 'Canaux de diffusion',
  'overview.connected': 'Connecté',
  'overview.fallback': 'Fallback actif',
  'overview.accounting': 'Accounting',
  'overview.accountingBody': 'Les journaux RADIUS restent centralisés pour la conformité et l’analytique.',
  'overview.operationalFlow': 'Flux opérationnel',
  'overview.flowAligned': 'Aligné sur les scénarios du document',
  'overview.channelMix': 'Mix des canaux',
  'overview.distributionSplit': 'Répartition de la diffusion',
  'overview.channelShare': '{share}% du total visible',
  'overview.infrastructure': 'Unités et VLAN',
  'overview.infrastructureDesc': 'Chambres, espaces communs et salles événementielles disponibles sur ce site.',
  'overview.alerts': 'Panneau d’alertes',
  'overview.alertsTitle': 'Risques et anomalies actuels',
  'overview.noAlerts': 'Aucune anomalie ouverte sur le site courant.',
  'overview.queue': 'File d’arrière-plan',
  'overview.queueTitle': 'État des imports massifs',
  'overview.queueProgress': '{processed}/{total} traités, VLAN cible {vlan}',
  'overview.credentials': 'Identifiants récents',
  'overview.credentialsTitle': 'Derniers DPSK émis',
  'overview.table.guest': 'Client',
  'overview.table.space': 'Unité',
  'overview.table.type': 'Type',
  'overview.table.vlan': 'VLAN',
  'overview.table.ssid': 'SSID',
  'overview.table.panMode': 'Mode PAN',
  'overview.table.source': 'Origine',
  'overview.table.channels': 'Canaux',
  'overview.table.validity': 'Validité',
  'overview.table.devices': 'Appareils',
  'overview.flow.trigger.title': 'Déclencheur PMS / réception',
  'overview.flow.trigger.body': 'Webhook, formulaire opérateur ou CSV génèrent la demande d’accès.',
  'overview.flow.normalize.title': 'Normalisation des identités',
  'overview.flow.normalize.body':
    'La plateforme attribue hôtel, unité, VLAN et fenêtre de validité.',
  'overview.flow.provision.title': 'Provisionnement du contrôleur réseau',
  'overview.flow.provision.body':
    'La DPSK est associée au VLAN mappé et à sa fenêtre de cycle de vie.',
  'overview.flow.deliver.title': 'Distribution des canaux',
  'overview.flow.deliver.body': 'TV, e-mail, dashboard ou impression reçoivent le QR code et le mot de passe.',
  'overview.flow.monitor.title': 'Supervision et accounting',
  'overview.flow.monitor.body':
    'L’usage, les files, l’adoption des canaux et l’accounting restent visibles pour operations.',
  'validation.required': 'Champ obligatoire.',
  'validation.email': 'Saisissez une adresse e-mail valide.',
  'validation.minValue': 'Saisissez une valeur valide.',
  'validation.fixErrors': 'Corrigez les champs mis en évidence avant d’enregistrer.',
  'validation.dateOrder': 'La date de fin doit être postérieure à la date de début.',
  'validation.selectOne': 'Sélectionnez au moins un élément.',
  'toast.dismiss': 'Fermer la notification',
  'toast.error.network': 'Impossible de joindre le service backend.',
  'toast.error.badRequest': 'La requête n’est pas valide.',
  'toast.error.unauthorized': 'Session non autorisée. Veuillez vous reconnecter.',
  'toast.error.forbidden': 'Vous n’avez pas les droits nécessaires pour effectuer cette opération.',
  'toast.error.notFound': 'La ressource demandée est introuvable.',
  'toast.error.conflict': 'L’opération ne peut pas être terminée à cause d’un conflit d’état.',
  'toast.error.validation': 'Les données envoyées ne sont pas valides.',
  'toast.error.server': 'Le serveur a renvoyé une erreur interne.',
  'toast.error.unavailable': 'Le service est temporairement indisponible.',
  'toast.error.genericStatus': 'Erreur HTTP {status} : échec de la requête.',
  'toast.error.unexpected': 'Une erreur inattendue s’est produite pendant l’appel HTTP.',
  'channel.tv': 'TV',
  'channel.email': 'E-mail',
  'channel.dashboard': 'Dashboard',
  'channel.print': 'Impression',
  'codeSource.pms': 'PMS',
  'codeSource.reception': 'Réception',
  'codeSource.bulk': 'Bulk',
  'queueStatus.queued': 'En file',
  'queueStatus.running': 'En cours',
  'queueStatus.completed': 'Terminé',
  'queueStatus.attention': 'Attention',
  'spaceKind.room': 'Chambre',
  'spaceKind.public-area': 'Espace commun',
  'spaceKind.event-hall': 'Salle événementielle',
  'assignment.room': 'Chambre',
  'assignment.group': 'Groupe',
  'assignment.common': 'Commun',
  'panMode.private': 'Privé',
  'panMode.shared-group': 'Groupe partagé',
  'panMode.public': 'Commun',
  'role.tv-integration': 'Intégration TV',
  'role.platform-admin': 'Platform admin',
  'role.tenant-admin': 'Administrateur',
  'role.reception': 'Conciergerie',
  'role.operations': 'Operations',
  'locationCategory.hotel': 'Hôtel',
  'locationCategory.resort': 'Resort',
  'locationCategory.conference': 'Site de conférence',
  'locationState.active': 'Actif',
  'locationState.disabled': 'Désactivé',
  'locationState.pending': 'En attente',
  'locationState.stable': 'Stable',
  'locationState.attention': 'Attention',
  'unitStatus.available': 'Disponible',
  'unitStatus.disabled': 'Désactivée',
  'unitStatus.occupied': 'Occupée',
  'userStatus.active': 'Actif',
  'userStatus.invited': 'Invité',
  'userStatus.disabled': 'Désactivé',
  'reception.tab.issue': 'Émission',
  'reception.tab.codes': 'Gestion des codes',
  'reception.tab.bulk': 'Import massif',
  'reception.summary.active': 'Actifs',
  'reception.summary.scheduled': 'Programmés',
  'reception.summary.archived': 'Archivés',
  'reception.summary.queue': 'Tâches massives',
  'reception.issue.kicker': 'Émission manuelle',
  'reception.issue.title': 'Créer un DPSK pour les clients et les cas exceptionnels',
  'reception.issue.description':
    'Pour les walk-ins, les fournisseurs, l’accès bar ou le fallback PMS. Générez un QR code et un mot de passe en clair.',
  'reception.fields.firstName': 'Prénom',
  'reception.fields.lastName': 'Nom',
  'reception.fields.email': 'E-mail',
  'reception.fields.space': 'Unité',
  'reception.fields.reference': 'Référence de réservation / voucher',
  'reception.fields.validFrom': 'Valide à partir de',
  'reception.fields.validUntil': 'Valide jusqu’au',
  'reception.fields.devicesAllowed': 'Appareils autorisés',
  'reception.fields.deliveryChannels': 'Canaux de diffusion',
  'reception.fields.notes': 'Notes opérateur',
  'reception.preview.kicker': 'Aperçu du voucher',
  'reception.preview.title': 'Carte opérateur',
  'reception.preview.empty': 'Sélectionnez une unité pour prévisualiser le QR code.',
  'reception.preview.guest': 'Client',
  'reception.preview.ssidVlan': 'SSID / VLAN',
  'reception.preview.panMode': 'Mode PAN',
  'reception.preview.expires': 'Expiration',
  'reception.lastCreated': 'Dernier code créé',
  'reception.lastCreatedEmpty':
    'Générez un DPSK manuel pour afficher ici le dernier récapitulatif du voucher.',
  'reception.generate': 'Générer le DPSK',
  'reception.creating': 'Création...',
  'reception.codes.kicker': 'Gestion des codes',
  'reception.codes.title': 'Filtrer, prolonger ou révoquer les vouchers',
  'reception.filter.all': 'Tous',
  'reception.filter.pms': 'PMS',
  'reception.filter.reception': 'Réception',
  'reception.filter.bulk': 'Massif',
  'reception.searchPlaceholder': 'Rechercher un client ou une référence',
  'reception.activeList': 'Actifs / programmés',
  'reception.archivedList': 'Archivés / invalides',
  'reception.actions.extend': '+24h',
  'reception.actions.revoke': 'Révoquer',
  'reception.actions.new': 'Nouveau DPSK',
  'reception.actions.backToCodes': 'Retour aux codes',
  'reception.actions.showQr': 'Afficher le QR',
  'reception.actions.printQr': 'Imprimer le QR',
  'reception.confirm.extend': 'Prolonger le voucher de {name} de 24 heures ?',
  'reception.confirm.revoke': 'Révoquer le voucher de {name} ?',
  'reception.activeEmpty': 'Aucun code actif ou programmé ne correspond aux filtres actuels.',
  'reception.archivedEmpty': 'Aucun code archivé ou révoqué ne correspond aux filtres actuels.',
  'reception.bulk.kicker': 'Intégration massive',
  'reception.bulk.title': 'Import CSV pour groupes et événements',
  'reception.bulk.loadFile': 'Charger un fichier',
  'reception.bulk.mode': 'Mode massif',
  'reception.bulk.modeShared': 'VLAN de groupe partagé',
  'reception.bulk.modeIsolated': 'VLAN / isolation par unité',
  'reception.bulk.defaultSpace': 'Unité par défaut',
  'reception.bulk.requestedBy': 'Demandé par',
  'reception.bulk.csvBody': 'Contenu CSV',
  'reception.bulk.queue': 'Mettre l’import en file',
  'reception.bulk.queueing': 'Mise en file...',
  'reception.bulk.templateHint':
    'Colonnes attendues : firstName, lastName, email, spaceId, validFrom, validUntil, devicesAllowed, bookingReference',
  'reception.bulk.jobs': 'État de la file',
  'reception.bulk.jobsTitle': 'Activité récente',
  'reception.emptyLocation': 'Sélectionnez ou créez un site avec des unités disponibles.',
  'reception.message.created': '{id} créé pour {name}.',
  'reception.message.bulkQueued': 'Tâche {id} mise en file avec {imported} identités ({status}).',
  'reception.message.extended': 'Validité prolongée de 24 heures pour {id}.',
  'reception.message.revoked': 'Code {id} révoqué.',
  'admin.vendorHintTitle': 'Catalogues de vendors',
  'admin.vendorHintBody':
    'Avant de créer ou de mettre à jour un site, vous pouvez enregistrer les catalogues vendor du contrôleur et du PMS afin que les menus déroulants et les champs de configuration soient prêts dans les formulaires de site.',
  'admin.card.tenants.label': 'Tenants',
  'admin.card.tenants.caption': 'Portefeuille multi-tenant géré depuis le panneau',
  'admin.card.locations.label': 'Sites',
  'admin.card.locations.caption': 'Hôtels, resorts et lieux événementiels disponibles dans le prototype',
  'admin.card.users.label': 'Utilisateurs',
  'admin.card.users.caption': 'Rôles opérationnels et affectations gérés via l’état mock',
  'admin.card.spaces.label': 'Unités / VLAN',
  'admin.card.spaces.caption': 'Inventaire courant des unités pour le site sélectionné',
  'admin.tab.tenants': 'Tenants',
  'admin.tab.locations': 'Sites',
  'admin.tab.users': 'Utilisateurs',
  'admin.tab.controllerVendors': 'Vendors du contrôleur',
  'admin.tab.pmsVendors': 'Vendors PMS',
  'admin.tab.infrastructure': 'Infrastructure',
  'admin.tenants.kicker': 'Gestion des tenants',
  'admin.tenants.title': 'Créer et mettre à jour les tenants',
  'admin.locations.kicker': 'Gestion des sites',
  'admin.locations.title': 'Gérer hôtels, resorts et lieux événementiels',
  'admin.locations.filterHint':
    'Sélectionnez un tenant pour n’afficher que ses sites associés, sans utiliser les filtres opérationnels globaux.',
  'admin.users.kicker': 'Gestion des utilisateurs',
  'admin.users.title': 'Rôles, périmètres tenant et périmètres site',
  'admin.controllerVendors.kicker': 'Catalogue contrôleur',
  'admin.controllerVendors.title': 'Enregistrer et gérer les vendors du contrôleur',
  'admin.controllerVendors.empty': 'Aucun vendor contrôleur n’est encore enregistré.',
  'admin.controllerVendors.emptyHint':
    'Ajoutez le premier vendor contrôleur pour le rendre disponible lors de l’onboarding des sites.',
  'admin.pmsVendors.kicker': 'Catalogue PMS',
  'admin.pmsVendors.title': 'Enregistrer et gérer les vendors PMS',
  'admin.pmsVendors.empty': 'Aucun vendor PMS n’est encore enregistré.',
  'admin.pmsVendors.emptyHint':
    'Ajoutez le premier vendor PMS pour le rendre disponible lors de l’onboarding des sites.',
  'admin.infrastructure.kicker': 'Inventaire et intégrations',
  'admin.infrastructure.title': 'Unités, VLAN et préparation des connecteurs',
  'admin.form.new': 'Nouveau',
  'admin.form.reset': 'Réinitialiser',
  'admin.form.create': 'Créer',
  'admin.form.update': 'Mettre à jour',
  'admin.form.name': 'Nom',
  'admin.form.brand': 'Marque / description',
  'admin.form.sla': 'SLA',
  'admin.form.coverage': 'Couverture DPSK %',
  'admin.form.city': 'Ville',
  'admin.form.category': 'Catégorie',
  'admin.form.pms': 'PMS',
  'admin.form.pmsVendor': 'Vendor PMS',
  'admin.form.pds': 'Config PDS',
  'admin.form.controller': 'Contrôleur',
  'admin.form.controllerVendor': 'Vendor du contrôleur',
  'admin.form.tv': 'Intégration TV',
  'admin.form.email': 'Intégration e-mail',
  'admin.form.integrations': 'Intégrations',
  'admin.form.state': 'État',
  'admin.form.dailyCheckIns': 'Check-ins quotidiens',
  'admin.form.activeGuests': 'Clients actifs',
  'admin.form.bulkQueue': 'File massive',
  'admin.form.note': 'Note opérationnelle',
  'admin.form.timezone': 'Fuseau horaire',
  'admin.form.linkedTenant': 'Tenant lié',
  'admin.form.role': 'Rôle',
  'admin.form.status': 'Statut utilisateur',
  'admin.form.tenantScope': 'Périmètre tenant',
  'admin.form.locationScope': 'Périmètre site',
  'admin.form.fieldSchema': 'Schéma de champs',
  'admin.form.fieldName': 'Nom du champ',
  'admin.form.fieldType': 'Type de champ',
  'admin.form.fieldsHelp': 'Définissez au moins un champ supplémentaire pour le vendor.',
  'admin.form.selectVendor': 'Sélectionner un vendor',
  'admin.form.selectVendorFirst': 'Sélectionnez d’abord un vendor pour configurer les champs requis.',
  'admin.form.pmsConfiguration': 'Configuration PMS',
  'admin.form.controllerConfiguration': 'Configuration du contrôleur',
  'admin.form.vendorConfigurationHint':
    'Renseignez tous les champs requis par l’entrée du catalogue vendor sélectionnée.',
  'admin.form.noPmsVendorsAvailable':
    'Aucun vendor PMS n’est encore disponible. Enregistrez d’abord le catalogue PMS.',
  'admin.form.noControllerVendorsAvailable':
    'Aucun vendor contrôleur n’est encore disponible. Enregistrez d’abord le catalogue contrôleur.',
  'admin.form.addField': 'Ajouter un champ',
  'admin.form.removeField': 'Supprimer le champ',
  'admin.form.createControllerVendor': 'Créer le vendor du contrôleur',
  'admin.form.createPmsVendor': 'Créer le vendor PMS',
  'admin.form.updateControllerVendor': 'Mettre à jour le vendor du contrôleur',
  'admin.form.updatePmsVendor': 'Mettre à jour le vendor PMS',
  'admin.form.controllerVendorNotFound': 'Vendor du contrôleur introuvable.',
  'admin.form.pmsVendorNotFound': 'Vendor PMS introuvable.',
  'admin.form.vendorFieldType.string': 'Texte',
  'admin.form.vendorFieldType.number': 'Nombre',
  'admin.form.vendorFieldType.boolean': 'Booléen',
  'admin.form.vendorFieldType.password': 'Mot de passe',
  'admin.form.unitType': 'Type d’unité',
  'admin.form.assignment': 'Affectation',
  'admin.form.unitStatus': 'Statut de l’unité',
  'admin.list.portfolio': 'Portefeuille',
  'admin.list.properties': 'Établissements',
  'admin.list.coverage': 'Couverture',
  'admin.list.alerts': 'Alertes',
  'admin.list.noneTenants': 'Aucun tenant n’est encore enregistré.',
  'admin.list.noneLocations': 'Aucun site disponible pour le tenant sélectionné.',
  'admin.tenants.emptyHint':
    'Créez le premier tenant pour démarrer l’onboarding multi-tenant de la plateforme.',
  'admin.actions.edit': 'Modifier',
  'admin.actions.toggleStatus': 'Basculer le statut',
  'admin.actions.newTenant': 'Nouveau tenant',
  'admin.actions.newLocation': 'Nouveau site',
  'admin.actions.newUser': 'Nouvel utilisateur',
  'admin.actions.newControllerVendor': 'Nouveau vendor du contrôleur',
  'admin.actions.newPmsVendor': 'Nouveau vendor PMS',
  'admin.actions.manageInfrastructure': 'Infrastructure',
  'admin.actions.backToLocation': 'Retour au site',
  'admin.actions.backToList': 'Retour à la liste',
  'admin.actions.delete': 'Supprimer',
  'admin.infrastructure.inventory': 'Inventaire des unités',
  'admin.infrastructure.roomAssignments': 'Affectations unitaires',
  'admin.infrastructure.roomAssignmentsDesc':
    'Chaque chambre est mappée individuellement avec SSID, VLAN et mode PAN. Utilisez cette zone pour créer ou corriger l’affectation d’une chambre.',
  'admin.infrastructure.locationScopeDesc':
    'Cette page appartient au site sélectionné. L’affectation de l’infrastructure est gérée directement dans le site.',
  'admin.infrastructure.sharedSpaces': 'Unités partagées et salles événementielles',
  'admin.infrastructure.noRooms': 'Aucune chambre n’est configurée pour le site sélectionné.',
  'admin.infrastructure.noSharedSpaces': 'Aucune unité partagée n’est configurée.',
  'admin.infrastructure.roomPreview': 'Aperçu de l’affectation',
  'admin.infrastructure.readiness': 'Préparation des intégrations',
  'admin.integrations.queuePlaceholder': 'Redis / RabbitMQ à définir côté backend',
  'admin.integrations.pdsPlaceholder': 'Configuration PDS à définir',
  'admin.form.createTenant': 'Créer le tenant',
  'admin.form.updateTenant': 'Mettre à jour le tenant',
  'admin.form.tenantNotFound': 'Tenant introuvable.',
  'admin.form.createLocation': 'Créer le site',
  'admin.form.updateLocation': 'Mettre à jour le site',
  'admin.form.locationNotFound': 'Site introuvable.',
  'admin.form.createUser': 'Créer l’utilisateur',
  'admin.form.updateUser': 'Mettre à jour l’utilisateur',
  'admin.form.userNotFound': 'Utilisateur introuvable.',
  'admin.form.roomName': 'Chambre',
  'admin.form.ssid': 'SSID',
  'admin.form.vlanId': 'VLAN',
  'admin.form.serviceVlanId': 'VLAN de service',
  'admin.form.networkId': 'ID réseau',
  'admin.form.capacity': 'Capacité',
  'admin.message.tenantSaved': 'Tenant {name} enregistré.',
  'admin.message.tenantDeleted': 'Tenant {name} supprimé.',
  'admin.message.locationSaved': 'Site {name} enregistré.',
  'admin.message.locationDeleted': 'Site {name} supprimé.',
  'admin.message.userSaved': 'Utilisateur {name} enregistré.',
  'admin.message.userDeleted': 'Utilisateur {name} supprimé.',
  'admin.message.controllerVendorSaved': 'Vendor du contrôleur {name} créé.',
  'admin.message.pmsVendorSaved': 'Vendor PMS {name} créé.',
  'admin.message.controllerVendorUpdated': 'Vendor du contrôleur {name} mis à jour.',
  'admin.message.pmsVendorUpdated': 'Vendor PMS {name} mis à jour.',
  'admin.message.controllerVendorDeleted': 'Vendor du contrôleur {name} supprimé.',
  'admin.message.pmsVendorDeleted': 'Vendor PMS {name} supprimé.',
  'admin.message.roomDeleted': 'Chambre {name} supprimée.',
  'admin.confirm.deleteTenant': 'Supprimer le tenant {name} et tous les sites liés ?',
  'admin.confirm.deleteLocation': 'Supprimer le site {name} et son infrastructure ?',
  'admin.confirm.deleteUser': 'Supprimer l’utilisateur {name} ?',
  'admin.confirm.deleteRoom': 'Supprimer la chambre {name} ?',
  'admin.confirm.deleteControllerVendor': 'Supprimer le vendor du contrôleur {name} ?',
  'admin.confirm.deletePmsVendor': 'Supprimer le vendor PMS {name} ?',
  'reception.tab.events': 'Événements',
  'reception.actions.sendEmail': 'Envoyer par e-mail',
  'reception.message.emailed': 'Code {id} envoyé par e-mail.',
  'events.kicker': 'Wi-Fi événementiel',
  'events.title': 'Créer et gérer les accès aux événements',
  'events.name': "Nom de l'événement",
  'events.hall': "Salle de l'événement",
  'events.duration': 'Durée',
  'events.code': "Code de l'événement",
  'events.isolation': 'Isolation des clients',
  'events.network.loading': 'Chargement des réseaux...',
  'events.network.empty': 'Aucun réseau disponible',
  'events.network.loadError': 'Impossible de charger les réseaux',
  'events.isolated': 'Isolé',
  'events.shared': 'Accès partagé',
  'events.policy': 'Politique',
  'events.contactName': 'Nom du contact',
  'events.create': 'Nouvel événement',
  'events.edit': "Modifier l'événement",
  'events.sendEmail': 'Envoyer le code par e-mail',
  'events.disable': "Désactiver l'événement",
  'events.empty': "Aucun événement n'est configuré pour cet emplacement.",
  'reception.tab.hotel': 'Hôtel', 'reception.hotel.description': 'Codes des chambres et espaces communs depuis le PMS ou la Conciergerie', 'reception.hotel.kicker': 'Codes Wi-Fi de l’hôtel', 'reception.hotel.title': 'Gérer les codes des chambres et espaces communs',
  'admin.onboarding.kicker': 'Création guidée du site', 'admin.onboarding.title': 'Créer et configurer un nouveau site', 'admin.onboarding.description': 'Suivez dans l’ordre le transfert du fournisseur vers Lumen.',
  'admin.onboarding.step1': 'Contrôleur', 'admin.onboarding.step2': 'Site', 'admin.onboarding.step3': 'Intégrations', 'admin.onboarding.step4': 'Validation', 'admin.onboarding.step5': 'Validation',
  'admin.onboarding.locationKicker': 'Étape 2 · Données du site', 'admin.onboarding.locationTitle': 'Saisir les données du nouveau site',
  'admin.onboarding.controllerKicker': 'Étape 1 · Connexion fournisseur', 'admin.onboarding.controllerTitle': 'Configurer le contrôleur du site', 'admin.onboarding.controllerHelp': 'Le matériel, la RF, les groupes AP et les SSID de base doivent exister chez le fournisseur.',
  'admin.onboarding.integrationsKicker': 'Étape 3 · Intégrations facultatives', 'admin.onboarding.integrationsTitle': 'Configurer PMS, TV et e-mail', 'admin.onboarding.reviewKicker': 'Étape 4 · Validation', 'admin.onboarding.reviewTitle': 'Confirmer la configuration du site', 'admin.onboarding.unitsNext': 'Après l’enregistrement, configurez chambres, unités partagées et salles événementielles avec VLAN et réseau.', 'admin.onboarding.saveContinue': 'Enregistrer et configurer les unités',
  'reception.fields.selectSpace': 'Sélectionner une unité',
  'reception.category.journalist': 'Journaliste',
  'reception.category.relator': 'Intervenant',
  'reception.categoryDescription.staff': 'Le code est créé sur le VLAN prédéfini.',
  'reception.categoryDescription.iot': 'Le code est créé sur le VLAN prédéfini.',
  'reception.categoryDescription.visitor': 'Le code est créé sur le VLAN prédéfini.',
  'reception.categoryDescription.guest': 'Sélectionnez la chambre pour associer son VLAN.',
  'events.message.saved': 'Événement {name} enregistré.',
  'events.message.emailSent': 'Code de l’événement envoyé à {email}.',
  'events.message.disabled': 'Événement {name} désactivé.',
  'events.codes.kicker': 'Gestion des clients et visiteurs',
  'events.codes.manage': 'Gérer les codes de l’événement',
  'events.codes.type': 'Type de code',
  'events.codes.mode': 'Mode de création',
  'events.codes.personal': 'Personnel',
  'events.codes.manual': 'Manuel',
  'events.codes.bulk': 'Import groupé',
  'events.codes.personalManual': 'Personnel · Manuel',
  'events.codes.personalBulk': 'Personnel · Import groupé',
  'events.codes.group': 'Groupe',
  'events.codes.manualTitle': 'Créer un code personnel',
  'events.codes.bulkTitle': 'Importer des codes personnels depuis un CSV',
  'events.codes.groupTitle': 'Créer un code de groupe',
  'events.codes.groupName': 'Nom du groupe',
  'events.codes.sendEmail': 'Envoyer le code par e-mail',
  'events.codes.service': 'Service',
  'events.codes.serviceHint': 'Utilisez le VLAN de service configuré pour la salle événementielle.',
  'events.codes.serviceUnavailable': 'Aucun VLAN de service n’est configuré pour la salle sélectionnée.',
  'events.codes.bulkHint': 'Colonnes obligatoires : firstName, lastName, email, category, devicesAllowed. La durée et la salle sont héritées de l’événement ; le traitement est mis en file d’attente pour respecter les limites de requêtes du fournisseur.',
  'events.codes.createPersonal': 'Créer un code personnel',
  'events.codes.createGroup': 'Créer un code de groupe',
  'events.codes.queueBulk': 'Mettre l’import CSV en file d’attente',
  'events.codes.personalCreated': 'Code personnel créé : {code}',
  'events.codes.groupCreated': 'Code de groupe créé : {code}',
  'events.codes.bulkQueued': 'Import {id} en attente : {imported} codes traités.',
  'admin.unitsBulk.action': 'Import en masse',
  'admin.unitsBulk.kicker': 'Import en masse des unités',
  'admin.unitsBulk.title': 'Importer des unités depuis un CSV',
  'admin.unitsBulk.description': 'Créez des chambres, des espaces communs et des salles événementielles en une seule opération.',
  'admin.unitsBulk.loadFile': 'Charger le CSV',
  'admin.unitsBulk.csv': 'CSV des unités',
  'admin.unitsBulk.hint': 'Colonnes : name, type, vlanId, serviceVlanId, networkId, panMode, capacity, assignment, status. Obligatoires : name, type, vlanId, networkId.',
  'admin.unitsBulk.importing': 'Importation...',
  'admin.unitsBulk.import': 'Importer les unités',
  'admin.unitsBulk.completed': '{count} unités importées.',
  'admin.unitsBulk.invalid': 'CSV invalide : {error}',
  'admin.unitsBulk.noRows': 'Aucune ligne de données trouvée.',
  'admin.unitsBulk.missingColumns': 'Colonnes manquantes : {columns}.',
  'admin.unitsBulk.rowError': 'Valeurs invalides à la ligne {row}.',
};
